import useSWR from 'swr'
import usePageContext from '../app/components/Page/context'
import { APIGetMedallists } from '../app/endpoints'

export function useMedalistsPhase2() {
  const {
    state: { getEnvConfig, labelsData }
  } = usePageContext()

  const { data } = useSWR(`${getEnvConfig.NEXT_CMS}${APIGetMedallists()}`)

  const groupByCategory = data?.data.reduce((acc: any, item: any) => {
    const category = item.attributes.category
    if (!acc[category]) {
      acc[category] = []
    }
    acc[category].push(item)
    return acc
  }, {})

  return {
    data,
    labelsData,
    groupByCategory
  }
}

export default useMedalistsPhase2